var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artistas"},[_c('ArtistsCarrousel',{staticClass:"artists-carousel-component",attrs:{"has-no-desktop-slider":true,"artists":_vm.artistsData}}),_c('UpcomingAuctions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }